import { createFileRoute } from '@tanstack/react-router'
import { DateTime } from 'luxon'

import { TripPage } from './trip.$tripId'

export const Route = createFileRoute('/trip/$tripId/$date')({ component: TripWithDate })

function TripWithDate() {
    const { tripId, date } = Route.useParams()
    const today = DateTime.local({ zone: 'Europe/Ljubljana' }).toFormat('yyyyMMdd')
    const queryDate = /^\d{8}$/.test(date) ? date : today

    return <TripPage tripId={tripId} queryDate={queryDate} />
}
